import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonList, DropdownButton, DropdownButtonContext, } from '@dixa/lib-shared-habla';
import { fieldOperators, filterOperatorLabels, } from '../../../../utils/definitions';
import styles from './conditionOperator.module.scss';
/**
 * Represents a dropdown component that is used to select a logical operator
 * while selecting multiple filters
 */
export const ConditionOperator = (props) => {
    const { condition, onChange } = props;
    const { operators } = fieldOperators[condition.field];
    const dropdown = (_jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => (_jsx(ButtonList, { children: operators.map((operator) => (_jsx(ButtonList.Item, Object.assign({ isSelected: operator === condition.operator, onClick: () => {
                    if (operator === condition.operator) {
                        return;
                    }
                    onChange(operator);
                    toggleDropdown();
                } }, { children: filterOperatorLabels[operator] }), operator))) })) }));
    return (_jsx(DropdownButton, Object.assign({ buttonProps: {
            variant: 'tertiary',
            styleText: false,
            className: styles.button,
        }, dropdown: dropdown, fixed: true }, { children: filterOperatorLabels[condition.operator] })));
};
